import * as React from 'react'
import * as css from './FooterLinks.module.css'
import { graphql, Link, useStaticQuery } from 'gatsby'
import clsx from 'clsx'

const FooterLinks = ({ hideLinks }) => {
	const { allSanityServicesPg, allSanityExpertisePg } = useStaticQuery(query)

	return (
		<ul className="flex gap-y-3 text-left md:flex-wrap md:justify-end <md:flex-col [&_a:hover]:underline">
			{!hideLinks && (
				<>
					<li className={css.parent}>
						<div>
							<Link to="/why-fastech" className="technical-lg">
								Why FASTECH
							</Link>
						</div>
						<ul className={css.children}>
							<li>
								<Link to="/leadership">Leadership</Link>
							</li>
							<li>
								<Link to="/careers">Careers</Link>
							</li>
							<li>
								<Link to="/internships">Internships</Link>
							</li>
						</ul>
					</li>
					<li className={css.parent}>
						<div className="technical-lg">Services</div>
						<ul className={css.children}>
							{allSanityServicesPg.nodes.map((link, key) => (
								<li key={key}>
									<Link to={`/services/${link.seo.slug.current}`}>
										{link.title}
									</Link>
								</li>
							))}
						</ul>
					</li>
					<li className={css.parent}>
						<div className="technical-lg">Expertise</div>
						<ul className={css.children}>
							{allSanityExpertisePg.nodes.map((link, key) => (
								<li key={key}>
									<Link to={`/expertise/${link.seo.slug.current}`}>
										{link.title}
									</Link>
								</li>
							))}
						</ul>
					</li>
					<li className={css.parent}>
						<div className="technical-lg">Products</div>
						<ul className={css.children}>
							<li>
								<Link to="/products/time-fill-post">Time-Fill Post</Link>
							</li>
							<li>
								<Link to="/products/sensor-lock-down">Sensor Lock Down</Link>
							</li>
							<li>
								<Link to="/products/watertight-manways">
									Watertight Manways
								</Link>
							</li>
						</ul>
					</li>
					<li className={css.parent}>
						<div className="technical-lg">Resources</div>
						<ul className={css.children}>
							<li>
								<Link to="/blog">Blog</Link>
							</li>
							<li>
								<Link to="/case-studies">Case Studies</Link>
							</li>
						</ul>
					</li>
				</>
			)}

			<li className={clsx(css.parent, '<md:!max-w-[initial]')}>
				<Link to="/contact" className="action <md:w-full">
					Contact
				</Link>
			</li>
		</ul>
	)
}

export default FooterLinks

const query = graphql`
	query FooterLinks {
		allSanityServicesPg(sort: { fields: orderRank }) {
			nodes {
				title
				seo {
					slug {
						current
					}
				}
			}
		}
		allSanityExpertisePg(sort: { fields: orderRank }) {
			nodes {
				title
				seo {
					slug {
						current
					}
				}
			}
		}
		allSanityProductsPg(sort: { fields: orderRank }) {
			nodes {
				title
				seo {
					slug {
						current
					}
				}
			}
		}
	}
`
